import RequiredFieldsFilterBar from '../RequiredFieldsFilterBar';
import RequiredFieldsList from '../RequiredFieldsList';

import RequiredFieldsHeader from './RequiredFieldsHeader';
import RequiredFieldsLayout from './RequiredFieldsLayout';
import useRequiredFieldsReport from './hooks';

const RequiredFieldsPage = () => {
  const { requiredFieldsReports, isLoading } = useRequiredFieldsReport();

  return (
    <RequiredFieldsLayout>
      <div>
        <RequiredFieldsHeader />
        <RequiredFieldsFilterBar />
      </div>
      <RequiredFieldsList requiredFieldsReports={requiredFieldsReports} loading={isLoading} />
    </RequiredFieldsLayout>
  );
};

export default RequiredFieldsPage;
